import { useRef, useState } from 'react'
import SurgeryEvaluation from '../surgicalTab/SurgeryEvaluation'
import PerformingSurgeonEvaluation from '../surgicalTab/PerformingSurgeonEvaluation'

import classes from '../SurgicalDrawer.module.css'
import FundsAvailable from '../surgicalTab/FundsAvailable'
import { useDispatch, useSelector } from 'react-redux'
import { caseActions } from '../../../../../store/case'
import { caseQuickUpdate } from '../../../../../lib/fetchApi'
import { notificationActions } from '../../../../../store/notifications'

const PREAUTH_NEEDED_FIELD = 'step_1_preauthorization_required'

export default function SurgicalDrawer2({itemData, apiCase}) {
    const dispatch = useDispatch()

    const userToken = useSelector(state => state.user.token)
    const activeCase = useSelector(state => state.case.activeCase)

    const [savingByField, setSavingByField] = useState({})
    const [preauthCheckboxKey, setPreauthCheckboxKey] = useState(0)
    const seqByFieldRef = useRef(new Map())

    const updateHandler = async (data) => {
        const field = data.identifier.field
        const isPreauthField = field === PREAUTH_NEEDED_FIELD
        const prevValue = isPreauthField ? itemData[field] : undefined

        let reqBody = {
            type: data.identifier.type,
            type_id: data.identifier.type_id,
            fields: {
                [field]: data.data.value,
            }
        }

        let requestSequence
        if (isPreauthField) {
            requestSequence = (seqByFieldRef.current.get(field) ?? 0) + 1
            seqByFieldRef.current.set(field, requestSequence)
            setSavingByField(prev => ({ ...prev, [field]: true }))
        } else {
            setTimeout(() => {
                dispatch(caseActions.modifyActiveCase({
                    folder: data.identifier.folder,
                    item: {
                        itemId: itemData.id,
                        field,
                        value: data.data.value,
                    },
                }))
            }, 0)
        }

        let update
        try {
            update = await caseQuickUpdate(
                userToken,
                activeCase.case.id,
                reqBody,
                dispatch,
                null,
                isPreauthField ? {
                    staleGuardKey: `${activeCase.case.id}:${data.identifier.type}:${data.identifier.type_id}:${field}`,
                    staleGuardSequence: requestSequence,
                } : undefined
            )
        } finally {
            if (isPreauthField && (seqByFieldRef.current.get(field) ?? 0) === requestSequence) {
                setSavingByField(prev => ({ ...prev, [field]: false }))
            }
        }

        if (update?.staleResponse) {
            return
        }

        if (update && update.errorMessage) {
            dispatch(notificationActions.setError(update))
            if (isPreauthField && (seqByFieldRef.current.get(field) ?? 0) === requestSequence) {
                dispatch(caseActions.modifyActiveCase({
                    folder: data.identifier.folder,
                    item: {
                        itemId: itemData.id,
                        field,
                        value: prevValue,
                    },
                }))
                setPreauthCheckboxKey(k => k + 1)
            }
            return
        }

        if (isPreauthField) {
            dispatch(caseActions.modifyActiveCase({
                folder: data.identifier.folder,
                item: {
                    itemId: itemData.id,
                    field,
                    value: data.data.value,
                },
            }))
        }
    }

    const isPreauthNeededSaving = Boolean(savingByField[PREAUTH_NEEDED_FIELD])

    return <div className={`${classes.drawer_container} ${classes.drawer_container_3}`}>

        <div className={classes.drawer_pannel}>
            <FundsAvailable currentSurgicalitem={itemData} updateHandler={updateHandler} apiCase={apiCase} preauthSaving={isPreauthNeededSaving} preauthCheckboxKey={preauthCheckboxKey}/>
        </div>

        <div className={classes.drawer_pannel}>
            <SurgeryEvaluation itemData={itemData} apiCase={apiCase} isPreauthNeededSaving={isPreauthNeededSaving}/>
        </div>

        <div className={`${classes.drawer_pannel} ${itemData.step_4_different_performing_surgeon ? '' : classes.drawer_pannel_inactive}`}>
            <PerformingSurgeonEvaluation itemData={itemData} apiCase={apiCase}/>
        </div>
    </div>
}
